import { apiService } from './api';
import { persistUserToLocalStorage } from './authService';
import {
  SequenceWaaSLoginRequest,
  SequenceWaaSLoginResponse,
} from '@/types/auth';

export class WaaSAuthService {
  private static instance: WaaSAuthService;

  private constructor() {}

  public static getInstance(): WaaSAuthService {
    if (!WaaSAuthService.instance) {
      WaaSAuthService.instance = new WaaSAuthService();
    }
    return WaaSAuthService.instance;
  }

  /**
   * Authenticate with Sequence WaaS JWT token
   * Backend verifies the JWT and returns Espotz access token
   */
  public async loginWithSequenceToken(
    data: SequenceWaaSLoginRequest,
  ): Promise<SequenceWaaSLoginResponse> {
    const response = await apiService.post<
      SequenceWaaSLoginResponse,
      SequenceWaaSLoginRequest
    >('/public/api/v1/auth/waas/login', data);

    // Store tokens in localStorage if login successful
    if (response.result?.accessToken) {
      localStorage.setItem('accessToken', response.result.accessToken);
      if (response.result.refreshToken) {
        localStorage.setItem('refreshToken', response.result.refreshToken);
      }
      persistUserToLocalStorage(response.result.user);
    }

    return response;
  }
}

export const waasAuthService = WaaSAuthService.getInstance();
